export const DOMAIN_TYPES = {
  ACADEMY: 0,
  JOB: 1,
  USER_SELECTED_JOB: 2,
  USER_JOB_GOAL: 3,
  USER_SKILL_GOAL: 4,
};

export const DOMAIN_TYPE_IDS = {
  ACADEMY: 0,
  JOB: 1,
  SKILL: 2,
};
